export default __webpack_public_path__ + "static/logo-fractal-4709bc36563f1e96f2b5f4899a934baf.svg";